<div class="mt-4">
  <div class="screen-label">
  <span><img src="../../../assets/resume-screening/screen-globe.svg" alt=""></span> <span> Screen </span> <span class="ai-text">AI</span>
  </div>
  <p class="f-20 font-weight-600 text-center mb-4">Cut Screening Time by 90%. Hire Faster.</p>
  <div class="screening-card-row">
    <div class="screen-card">
      <p class="title-text">Job Description</p>
      <img src="../../../assets/resume-screening/job-description.svg" alt="">
      <p>Set up your job details.</p>
    </div>
    <div class="screen-card">
      <p class="title-text">Screen <span class="ai-text">AI</span> <span class="ml-2">Criteria</span></p>
      <img src="../../../assets/resume-screening/screen-criteria.svg" alt="">
      <p>Go beyond keywords. Specify the skills, experiences, and attributes that really define success in your role.</p>
    </div>
    <div class="screen-card">
      <p class="title-text">Resume</p>
      <img src="../../../assets/resume-screening/ressume.svg" alt="">
      <p>Connect your ATS or simply upload resumes — no setup headaches, no messy imports.</p>
    </div>
    <div class="screen-card">
      <p class="title-text">Insights</p>
      <img src="../../../assets/resume-screening/insights.svg" alt="">
      <p>Our AI screens every candidate with human-like context — delivering transparent, fair, and data-driven rankings.</p>
    </div>
  </div>
</div>
